import { type BaseJsonConfiguration, type TTlds } from '@dhl/receiver-config'

export const pwaTlds = ['nl'] as const
export type PwaTlds = typeof pwaTlds

export type PwaAppConfiguration = {
  apiGatewayHost: string
  basePath: string
  features: {
    additionalAddressLine: {
      active: boolean
    }
    c2c: {
      active: boolean
      activationPercentage: number
      excludedHosts: string[]
    }
    expressEconomy: {
      active: boolean
    }
    fxtAaaExp: {
      active: boolean
    }
    loyalty: {
      active: boolean
      endpoint: string
    }
    maintenance: {
      active: boolean
    }
    whatsNew: {
      active: boolean
    }
    payment: {
      active: boolean
      paymentMethodSelectionEnabled: boolean
      issuerSelectionEnabled: boolean
      waitForPayment: {
        active: boolean
        durationInSeconds: number
        pollInSeconds: number
      }
    }
  }
  adobe: {
    url: string
  }
  datadog: {
    applicationId: string
    clientToken: string
    service: string
    logsSessionSampleRate: number
    rumSessionSampleRate: number
    rumSessionReplaySampleRate: number
  }
  emailUrl: string
  gtm: {
    id: string
  }
  maps: {
    apiKey: string
  }
  migration: {
    mode: string
  }
  mopinion: {
    token: string
  }
  navigation: string
  oneTrust: {
    id: string
    enableForNative: boolean
    enableForNativeFromVersion: string
  }
  postHog: {
    apiKey: string
  }
  prismic: {
    endpoint: string
  }
  recaptcha: {
    siteKey: string
  }
  shipperAddressType: string
  util: {
    tldOverride?: string
  }
}
export type JsonConfiguration<
  TSupportedTlds extends TTlds,
  TAppConfiguration = PwaAppConfiguration,
> = BaseJsonConfiguration<TSupportedTlds, TAppConfiguration> & {
  BASE_PATH: string
}
